import React from "react";
import { createBrowserRouter } from "react-router-dom";
import NotFound from "./pages/NotFound/NotFound";
import LoggingInPage from "./pages/onboarding/LoggingInPage/LoggingInPage";
import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute";
import { GuestRoute } from "./components/GuestRoute/GuestRoute";
import { ROUTES } from "./utils/constants";
import GamesPage from "./pages/GamesPage/GamesPage";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import AppLayout from "./components/layouts/AppLayout/AppLayout";
import GameFlowPage from "./pages/GameFlowPage/GameFlowPage";
import SignUpStartFlowPage from "./pages/SignUpStartFlowPage/SignUpStartFlowPage";
import SignUpWelcomeFlowPage from "./pages/SignUpWelcomeFlowPage/SignUpWelcomeFlowPage";
import LoginStartFlowPage from "./pages/LoginStartFlowPage/LoginStartFlowPage";
import LoginWelcomeFlowPage from "./pages/LoginWelcomeFlowPage/LoginWelcomeFlowPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import ResultPage from "./pages/ResultPage/ResultPage";
import EditProfilePage from "./pages/EditProfilePage/EditProfilePage";
import ManageSubscription from "./pages/ManageSubscription/ManageSubscription";
import GenresPage from "./pages/GenresPage/GenresPage";

const router = createBrowserRouter([
  {
    path: "",
    element: <AppLayout />,
    children: [
      {
        path: ROUTES.ROOT.HOME,
        element: (
          <ProtectedRoute redirectPath={ROUTES.GAMES.ROOT}>
            <DashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.GAMES.ROOT,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.GAME,
        element: <GamesPage />,
      },
      {
        path: ROUTES.GAMES.GENRES,
        element: <GenresPage />,
      },
      {
        path: ROUTES.GAMES.GENRE,
        element: <GenresPage />,
      },
      {
        path: `${ROUTES.GAMES.ROOT}/:gameSlug${ROUTES.ROOT.SOLO_GAME}`,
        element: <GameFlowPage />,
      },
      {
        path: `${ROUTES.GAMES.ROOT}/:gameSlug/:tournamentId`,
        element: <GameFlowPage />,
      },
      {
        path: ROUTES.ROOT.PROFILE,
        element: (
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.ROOT.EDIT_PROFILE,
        element: (
          <ProtectedRoute>
            <EditProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.ROOT.MANAGE_SUBSCRIPTION,
        element: (
          <ProtectedRoute>
            <ManageSubscription />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.ROOT.RESULTS,
        element: (
          <ProtectedRoute>
            <ResultPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.ROOT.SIGN_UP,
        children: [
          {
            path: "",
            element: (
              <GuestRoute allowOnboarding>
                <SignUpStartFlowPage />
              </GuestRoute>
            ),
          },
          {
            path: ROUTES.SIGN_UP.WELCOME,
            element: (
              <ProtectedRoute requireOnboarding>
                <SignUpWelcomeFlowPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: ROUTES.ROOT.LOG_IN,
        children: [
          {
            path: "",
            element: (
              <GuestRoute>
                <LoginStartFlowPage />
              </GuestRoute>
            ),
          },
          {
            path: ROUTES.LOG_IN.WELCOME,
            element: (
              <ProtectedRoute requireOnboarding>
                <LoginWelcomeFlowPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: ROUTES.ROOT.LOGGING_IN,
        element: <LoggingInPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

export default router;
